<template>
  <div class="sightseeing-card" v-if="!isShopCard">
    <div class="card-bd">
      <van-radio-group v-model="checkData" :disabled="!isShowRadio">
        <!--精品游-->
        <div class="boutique-tour-bpx" v-if="cardData">
          <div class="item-top-tag-box is-tab" v-if="!isBookingDeatail">
            <div class="item-top-tag" v-if="cardData.filter(item=>item.shorexType===2).length > 0" :class="{'active': tabShorexType===2}" @click="changeShoreTab(2)">精品游</div>
            <div class="item-top-tag" v-if="cardData.filter(item=>item.shorexType===1).length > 0" :class="{'active': tabShorexType===1}" @click="changeShoreTab(1)">常规游</div>
          </div>
          <div class="item-top-tag-box booking" v-else>
            <div class="item-top-tag" v-if="cardData[0].shorexType===2">皇家精品游（付费）</div>
            <div v-if="cardData[0].shorexType===1" style="display: flex;align-items: center;gap: 8px">
              <div class="item-top-tag">皇家常规游（免费）</div>
            </div>
          </div>
          <div class="list-box" v-for="(payItem,index) in cardData" :key="index" v-show="tabShorexType===payItem.shorexType">
            <div class="list-hd">
              <van-radio :name="payItem.id" :disabled="orderStatus==1&&payItem.cannotChange" v-if="isShowRadio" @click="handleCheckProduct(payItem.id)">
                <div slot="default" class="item-hd flex-between-box">
                  <div class="item-hd-left blue-color">{{payItem.shorexName}}</div>
                  <div class="item-hd-right"> <span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人<div>(上船自动房卡扣款)</div></div>
                </div>
                <template #icon="props">
                  <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                  >
                  <i class="checked-item" v-if="props.checked"></i>
                </template>
              </van-radio>
              <div v-else-if="isTravelPage">
                <div slot="default" class="item-hd flex-start-box">
                  <div class="item-hd-left">
                    <div class="blue-color" style="margin-bottom:5px">{{payItem.shorexName}}</div>
                    <div class="price"><span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人 </div>
                  </div>
                  <div class="item-hd-right">
                    <van-button v-if="payItem.outOfStock == false" type="default" size="small" class="btn-common small item-btn btn-cart"
                                :class="{
                                  'is-disabled': checkData === payItem.id,
                                  'is-default': checkData !== payItem.id && checkData > 0
                                }"
                                :disabled="checkData === payItem.id" @click="handleCheckProduct(payItem.id)">
                      <img v-if="checkData === 0" class="icon" src="../../assets/icons/icon_cart.png" alt="">
                      <div>{{checkData === payItem.id ? '已选择该线路' : checkData === 0 ? '加入购物车' : '更改至该线路'}}</div>
                    </van-button>

                    <!-- start -->
                     <sell-line-btn v-else/>
                    
                    <div class="sell-line" v-if="payItem.showLowStock == true" >
                     <sell-line-tip line/>
                    </div>
                    <!-- end -->


                    <!-- <a href="javascript:;" class="btn-common small item-btn btn-cart" @click="checkItem(payItem.id)"></a> -->
                  </div>
                </div>
              </div>
              <div v-else>
                <div slot="default" class="item-hd flex-between-box only-detail" style="align-items: self-start;">
                  <div class="item-hd-left item-hd-left-line">
                    <div class="blue-color is-title sell-line-box">{{payItem.shorexName}}
                      <div class="sell-line-left" v-if="payItem.showLowStock == true"> 
                        <sell-line-tip v-if="payItem.showLowStock == true" size="26"/>
                      </div>
                    </div>
                    <div v-if="priceFormat(payItem.price)>0" class="price" ><span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人  <span class="number">x{{personNumber}}</span></div>
                  </div>
                  <div class="item-hd-right">
                    <div v-if="isBookingDeatail">
                      <div v-if="cardData[0].shorexType===2" @click="goToShorex" class="changeShorex">
                        改换线路
                      </div>
                      <div v-else class="freeShore">
                        <div @click="goToShorex">升级精品游</div>
<!--                        <div v-if="!isTerms" @click="cancelFreeShorex" style="background-color: #e2e2e2;color: #303030">取消预订</div>-->
                      </div>
                    </div>
                    <span class="price-color" v-if="priceFormat(payItem.price)>0">{{priceFormat(payItem.price*personNumber)}}</span>
                    <span v-if="priceFormat(payItem.price)>0">美元</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-bd">
              <TourList :listData="payItem.shorexTours" :shorexType="payItem.shorexType" :isBookingDeatail="isBookingDeatail"/>
            </div>
          </div>
        </div>
      </van-radio-group>
    </div>
    <div class="shorex-notes">
      注：
      <ul>
        <li>1)目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</li>
        <li>2)目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</li>
        <li>3)皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。</li>
        <template v-if="isBookingDeatail">
          <li v-if="cardData && cardData[0].shorexType===2">4)如需取消已预订的精品游订单，请联系皇家行前订客服协助操作。</li>
          <li v-else-if="cardData && cardData[0].shorexType===1">4)如需升级成精品游，您可点击“升级精品游”按钮直接进入超凡观光页面选择提交。</li>
          <li v-else>4)2025年上海出发适用于常规游行程的目的地为福冈、长崎、冲绳及釜山。</li>

          <template v-if="(cardData && cardData[0].shorexType===2) || (cardData && cardData[0].shorexType===1)">
            <li>5)2025年上海出发适用于常规游行程的目的地为福冈、长崎、冲绳及釜山。</li>
          </template>
        </template>
        <template v-else>
          <li>4)2025年上海出发适用于常规游行程的目的地为福冈、长崎、冲绳及釜山。</li>
        </template>
      </ul>
    </div>
  </div>
  <div v-else class="sightseeing-card">
    <!--else内代码废弃-->
<!--    <div class="card-bd" v-if="cardData && cardData.length>0">-->
<!--      <van-radio-group v-model="checkData" :disabled="!isShowRadio">-->
<!--        <div class="boutique-tour-bpx">-->
<!--          <div class="list-box" v-for="(payItem,index) in cardData" :key="index" v-show="payItem.id===checkId">-->
<!--            <div class="list-hd">-->
<!--              <van-radio :name="payItem.id" :disabled="orderStatus==1&&payItem.cannotChange" v-if="isShowRadio" @click="checkItem(payItem.id,false)">-->
<!--                <div slot="default" class="item-hd flex-between-box">-->
<!--                  <div class="item-hd-left blue-color">{{payItem.shorexName}}</div>-->
<!--                  <div class="item-hd-right"> <span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人<div>(上船自动房卡扣款)</div></div>-->
<!--                </div>-->
<!--                <template #icon="props">-->
<!--                  <img-->
<!--                      class="img-icon"-->
<!--                      :src="props.checked ? activeIcon : inactiveIcon"-->
<!--                  >-->
<!--                  <i class="checked-item" v-if="props.checked"></i>-->
<!--                </template>-->
<!--              </van-radio>-->
<!--              <div v-else-if="isTravelPage">-->
<!--                <div slot="default" class="item-hd flex-center-box">-->
<!--                  <div class="item-hd-left">-->
<!--                    <div class="blue-color" style="margin-bottom:5px">{{payItem.shorexName}}</div>-->
<!--                    <div class="price"><span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人 </div>-->
<!--                  </div>-->
<!--                  <div class="item-hd-right">-->
<!--                    <van-button type="default" size="small" class="btn-common small item-btn btn-cart" :disabled="checkData === payItem.id" @click="checkItem(payItem.id, false)">-->
<!--                      <img class="icon" src="../../assets/icons/icon_cart.png" alt="">-->
<!--                      {{checkData === payItem.id ? '已预订' :'立即预订'}}-->
<!--                    </van-button>-->
<!--                    &lt;!&ndash; <a href="javascript:;" class="btn-common small item-btn btn-cart" @click="checkItem(payItem.id)"></a> &ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-else>-->
<!--                <div slot="default" class="item-hd flex-between-box only-detail">-->
<!--                  <div class="item-hd-left">-->
<!--                    <div class="blue-color">{{payItem.shorexName}}</div>-->
<!--                    <div class="price"><span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人  <span class="number">x{{personNumber}}</span></div>-->
<!--                  </div>-->
<!--                  <div class="item-hd-right"> <span class="price-color">{{priceFormat(payItem.price*personNumber)}}</span> 美元 <div></div></div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="list-bd">-->
<!--              <TourList :listData="payItem.shorexTours" :shorexType="payItem.shorexType" :isBookingDeatail="isBookingDeatail"/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </van-radio-group>-->
<!--    </div>-->
    <div class="shorex-notes">
      注：
      <ul>
        <li>1)目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</li>
        <li>2)目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</li>
        <li>3)皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。</li>
        <li v-if="cardData && cardData[0].shorexType===1">4)*如需升级成精品游，您可点击“升级精品游”按钮直接进入超凡观光页面选择提交。</li>
        <li v-else-if="cardData && cardData[0].shorexType===2">4)如需取消已预订的精品游订单，请联系皇家行前订客服协助操作。</li>
        <li v-else>4) 2025年上海出发适用于常规游行程的目的地为福冈、长崎、冲绳及釜山。</li>

        <template v-if="(cardData && cardData[0].shorexType===1) || (cardData && cardData[0].shorexType===2)">
          <li>5) 2025年上海出发适用于常规游行程的目的地为福冈、长崎、冲绳及釜山。</li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import TourList from './TourList'
import groupBy from 'lodash/groupBy'
import {hideLoading, showAlert, showLoading} from '@/utils/tools'
import api from '@/api'
// import { checkOrderState } from '@/plugins/common'
import { setCookie, getCookie } from '@/utils/cookie'
import { Dialog } from 'vant'
import SellLineTip from '@/components/SellLineTip'
import SellLineBtn from '@/components/SellLineBtn'

export default {
  name: 'SightseeingCard',

  components: {
    TourList,
    SellLineTip,
    SellLineBtn
  },

  data () {
    return {
      checkData: '',
      listData: {},
      activeIcon: require('../../assets/check_ico_on.png'),
      inactiveIcon: require('../../assets/check_ico.png'),
      checkDataBack: '',
      defaultFreeShorexId: '',
      tabShorexType:2, // 2精品 1常规
    }
  },

  props: {
    isShowRadio: {
      type: Boolean,
      default: false
    },
    isTravelPage: {
      type: Boolean,
      default: false
    },
    checkId: Number,
    orderStatus: {
      type: Number,
      default: 0
    },
    cardData: {
      type: Array,
      default: function () {
        return []
      }
    },
    personNumber: {
      type: Number,
      default: 0
    },
    isShowDel: {
      type: Boolean,
      default: false
    },
    isShowTour: {
      type: Boolean,
      default: false
    },
    canDeletedPayShorex: {
      type: Boolean,
      default: false
    },
    isCardOrder: {
      type: Boolean,
      default: false
    },
    isShopCard:{
      type: Boolean,
      default: false
    },
    isBookingDeatail:{
      type: Boolean,
      default: false
    },
    bookingShoreType:{
      type:Number,
      default: 2
    },
    isTerms:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    showCartCancelOrder() {
      return this.$store.state.showCartCancelOrder
    }
  },
  watch: {
    cardData (val) {
      console.log(val)
      this.listData = this.editListData(val)
      if(this.listData) {
        let index = Object.keys(this.listData)[0];
        this.defaultFreeShorexId = this.listData[index][0].id;
      }
    },
    checkId (val) {
      console.log('checkId', val)
      this.checkData = val
      this.checkDataBack = val
    },
  },
  created () {
    this.listData = this.editListData(this.cardData)
    if(this.isBookingDeatail){
      this.tabShorexType = this.bookingShoreType
    }
    if(this.listData) {
      let index = Object.keys(this.listData)[0];
      this.defaultFreeShorexId = this.listData[index][0].id;
    }
    // this.$store.commit('store', {
    //   showCartCancelOrder: false
    // });
    this.tabShorexType = this.cardData[0].shorexType
    this.checkData = this.checkId
    this.checkDataBack = this.checkId
  },
  methods: {
    priceFormat (current) {
      console.log('pcurrent',current)
      return current % 1 === 0 ? current : current.toFixed(2)
    },
    //点击岸上观光单选框
    // async checkItem(val, isFree) {
    //   // console.log('val--'+val+'===checkDataBack--'+this.checkDataBack+'===checkData--'+this.checkData+'===isFree--'+isFree)
    //   // this.doCheckOrderState(val, isFree);
    //   await checkOrderState((checkResult, orderStatus, orderIsInChange) => {
    //     //订单状态检查或订单更改为修改中状态报错
    //     if (checkResult) {
    //       if (checkResult === 'cancel') {
    //         this.checkData = this.checkId
    //       } else {
    //         showAlert(checkResult)
    //       }
    //     } else {
    //       // 订单未提交
    //       if (orderStatus === 0) {
    //         //取消勾选
    //           if(!this.isShopCard){
    //             if(val === this.checkDataBack){
    //               this.checkProduct(0)
    //             }else{
    //               this.checkProduct(val)
    //             }
    //           }else{
    //             let arrPrice = this.cardData[0].price * this.personNumber
    //             this.$store.commit('store', {
    //               isCheckShorex: true
    //             });
    //             if(val === this.checkDataBack){
    //               this.checkData = ''
    //               this.checkDataBack = ''
    //               this.$emit('calcShopCard',{price:arrPrice,type:'cancel',id:0})
    //             }else{
    //               this.checkData = val
    //               this.checkDataBack = val
    //               this.$emit('calcShopCard',{price:arrPrice,type:'add',id:val})
    //             }
    //           }
    //       } else if (orderStatus === 1 && orderIsInChange) {
    //         //订单已提交 && 订单可变更
    //         // 取消勾选
    //         if(val === this.checkDataBack && !this.$store.state.showCartCancelOrder) {
    //           //精品游反选
    //           if(!isFree) {
    //             if(this.canDeletedPayShorex) {
    //               this.checkProduct(0)
    //               if(this.defaultFreeShorexId) this.checkProduct(this.defaultFreeShorexId);
    //             } else {
    //               showAlert('仅可切换不可取消，如需取消请联系皇家行前订客服')
    //             }
    //           } else {
    //             //常规游反选
    //
    //             //可取消订单
    //             // if(canCancelOrder) {
    //             //   Dialog.confirm({
    //             //     message: '请点击”取消订单“确认取消常规游行程'
    //             //   }).then(() => {
    //             //     this.checkData = "";
    //             //     this.$emit('shorexChange', {
    //             //       showCartCancelOrder: true
    //             //     });
    //             //   }).catch(() => {
    //             //     this.checkData = this.checkId
    //             //   })
    //             // } else {
    //             //   if(this.isCardOrder) {
    //             //     Dialog.confirm({
    //             //       message: '确定要删除该产品？'
    //             //     }).then(() => {
    //             //       this.checkProduct(0)
    //             //     }).catch(() => {
    //             //       this.checkData = this.checkId
    //             //     })
    //             //   } else {
    //             //     this.checkProduct(0)
    //             //   }
    //             // }
    //           }
    //         } else {
    //           //勾选其它岸上观光 && 是精品游
    //           if (!this.isTravelPage && !isFree) {
    //             Dialog.confirm({
    //               message: '该操作将替换原有线路'
    //             }).then(() => {
    //               this.checkProduct(val)
    //             }).catch(() => {
    //               this.checkData = this.checkId
    //             })
    //           } else {
    //             this.checkProduct(val)
    //           }
    //         }
    //       } else {
    //         // this.$emit('checkval')
    //         this.checkProduct(val)
    //       }
    //     }
    //   }, this.isTravelPage)
    // },
    editListData (val) {
      for (let index = 0; index < val.length; index++) {
        if (val[index].id === this.checkId) {
          val[index].checkStatus = true
        } else {
          val[index].checkStatus = false
        }
      }
      return groupBy(val, 'shorexType')
    },
    handleCheckProduct(val) {
      if(this.checkId && this.checkId !== val) {
        Dialog.confirm({
          message: '该操作将替换原有线路'
        }).then(() => {
          this.checkProduct(val)
        }).catch(() => {
          this.checkData = this.checkId
        })
      } else {
        this.checkProduct(val)
      }
    },
    // 选择产品
    async checkProduct (val) {
      if(val!==0) {
        this.$emit('shorexChange', {
          showCartCancelOrder: false
        });
      }
      showLoading()
      const { errCode, errMsg } = await api.addProduct({ shorexId: val })
      hideLoading()
      if (errCode === 0) {
        this.checkDataBack = val
        this.$emit('checkval')
        if (this.isTravelPage && !getCookie('shorexId')) {
          setCookie('shorexId', val)
        }
      } else {
        this.checkData = this.checkDataBack
        showAlert(errMsg)
      }
    },
    // 删除产品
    async deleteProduct (val) {
      const { errCode, errMsg } = await api.deleteProduct({ shoppingCartIds: [val] })
      if (errCode === 0) {
        this.checkData = ''
        this.checkDataBack = ''
        this.$emit('checkval')
      } else {
        showAlert(errMsg)
      }
    },
    goCart () {
      // this.$emit('changeOrder')
      this.$router.push('/page_shopping_cart')
    },
    changeShoreTab(val){
      this.tabShorexType = val
    },
    goToShorex(){
      this.$router.push({
        path:'/Rccl.PCP/product/pcpShorex'
      })
    },
    // 取消常规游
    async cancelFreeShorex() {
      showLoading()
      const {errCode, errMsg} = await api.cancelOrderWithOnlyFreeShorex()
      if (errCode === 0) {
        showAlert('常规游订单已取消').then(async () => {
          this.$store.commit('store', {
            showCartCancelOrder: false,
            cartCancelOrder: false
          })
          await this.$router.push({
            path: '/Rccl.PCP/product/pcpShorex'
          })
        });
      } else {
        showAlert(errMsg).then(async () => {});
      }
      hideLoading()
    }
  }
}
</script>

<style lang="less" scoped>
.sightseeing-card{
  ::v-deep .price-color{
    color: @second-color;
  }
  ::v-deep .blue-color{
    color: #1174b8;
  }
  .item-top-tag-box {
    padding: 20px 0 0;
    display: flex;
    align-items: center;
    gap: 30px;
    justify-content: center;
    & .item-top-tag{
      margin: 0;
    }
    .active{
      background-image: linear-gradient(to right, #ffdb17, #fcbf00);
      color: #000;
    }
    &.is-tab {
      width: 100%;
      gap: 0;
      & .item-top-tag {
        height: 54px;
        line-height: 54px;
        flex: 1;
        border-radius: 0;
        background-color: #e5e5e5;
        color: #646464;
        &.active{
          background-image: linear-gradient(to right, #ffdb17, #fcbf00);
          color: #000;
        }
      }
    }
  }
  .booking{
    padding-top: 30px;
    display: block;
    background-color: #fff;
    & .item-top-tag {
      width: 100%;
      padding: 0 20px 0 40px;
      text-align: left;
      background-color: transparent;
      color: #616161;
      &::after {
        position: absolute;
        content: " ";
        top: 7px;
        left: 20px;
        width: 10px;
        height: 10px;
        border-radius: 16px;
        background-color: #fdc401;
      }
    }
  }
  .item-top-tag{
    position: relative;
    font-size: 24px;
    line-height: 24px;
    color: @main-gray3;
    padding: 5px 20px;
    //width: 100px;
    text-align: center;
    background-color: #f0f0f0;
    //margin: 20px auto;
    // display: inline-block;
    margin: 0 auto;
    border-radius: 46px;
  }
  .left{
    margin-left: 20px;
  }
  .card-bd{
    ::v-deep .van-cell{
      padding: 0.3rem 0.3rem 0;
    }
    .img-icon {
      height: 24px;
    }
    /deep/.van-radio__label{
      flex: 1;
    }
    /deep/.van-radio{
      align-items: flex-start;
      -webkit-align-items: flex-start;
      & .van-radio__icon {
        margin-top: -2px;
      }
    }
    // .item-top-tag{
    //   margin: 20px;
    // }
    .list-box{
      position: relative;
      border-bottom: 1px solid @main-gray5;
      //margin-bottom: 40px;
      padding: 40px 0 0;
      background-color: #fff;
      &:last-child{
        border-bottom: none;
        // display: none;
        //margin-bottom: 0;
      }
    }
    .list-del {
      margin-top: 20px;
      & .del-btn {
        width: 85px;
        height: 46px;
        line-height: 46px;
        color: #333333;
        text-align: center;
        border-radius: 6px;
        font-size: 18px;
        padding: 0;
        border:none;
      }
    }
    .list-hd{
      padding: 0 20px;
      ::v-deep .van-checkbox__label{
        width: 100%;
      }
      .item-hd{
        font-size: 20px;
        color: @main-gray4;
        .item-hd-left{
          font-size: 26px;
          padding-right: 105px;
          flex: 1;
          & .is-title {
            line-height: 42px;
          }
          .price{
            font-size: 24px;
            .price-color{
              font-size: 30px;
            }
          }
        }
        .item-hd-right{
          text-align: right;
          .price-color{
            font-size: 30px;
          }
          .changeShorex{
            padding: 0 22px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            color: #000;
            font-size: 18px;
            border-radius: 8px;
            background-color: #fcc302;
          }
          .freeShore{
            display: flex;
            align-items: center;
            gap: 16px;
            div{
              padding: 4px 22px;
              text-align: center;
              background-color: #fcc302;
              font-size: 18px;
              border-radius: 8px;
              color: #fff;
            }
          }
        }
      }
      .only-detail{
        align-items: flex-end;
        .price{
          font-size: 20px;
          .number{
            margin-left: 10px;
          }
        }
      }
    }
    ::v-deep .top-text-box{
      flex: 1;
      padding-left: 30px;
      font-size: 20px;
      line-height: 30px;
      margin-top: 5px;
      .title{
        font-size: 26px;
        color: @main-color;
      }
      .route{
        margin-top: 4px;
        color: @main-gray2;
      }
      .duration{
        color: @main-gray4;
        padding-top: 25px;
        line-height: 1;
      }
    }
    .top-text-tools {
      display: flex;
      justify-content: center;
      padding: 20px;
      & .tools-btn {
        width: 200px;
        height: 50px;
        line-height: 50px;
        color: #333333;
        text-align: center;
        border-radius: 6px;
        font-size: 24px;
        padding: 0;
        border:none;
      }
    }
    .routine-tour-box{
      //background-color: #f5f7f8;
      .list-hd{
        margin-bottom: 20px;
        .item-hd{
          .item-hd-right{
            text-align: right;
            .price-color{
              font-size: 30px;
            }
          }
        }
      }
      .list-bd-top{
        padding: 0px 20px 20px;
      }
    }
  }
  .item-btn {
    width: 160px;
    height: 50px;
    border-radius: 6px;
    border: none;
    display: flex;
    align-items: center;
    text-align: center !important;
    ::v-deep .van-button__content{
      text-align: center !important;
    }
    ::v-deep .van-button__text {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .icon {
      display: block;
      margin-right: 5px;
    }
    &.btn-detail {
      color: #fff;
      background: #1174b8;
      .icon {
        width: 14px;
      }
    }
    &.btn-cart .icon {
      width: 21px;
    }
    &.del{
      width: 85px;
      ::v-deep .van-button__content{
        width: 100%;
      }
    }
  }
}
.shorex-notes{
  padding: 0.3rem;
  color: #1b1b1b;
  font-size: 20px;
  background-color: #fff;
}

.sell-line{
  margin-top: 26px;
  display: flex;
  justify-content: flex-end;
}
.sell-line-left{
  margin-left: 12px;
  flex-shrink: 0;
}
.sell-line-box{
  display: flex;
}
.item-hd-left-line{
  padding-right: 30px !important;
}

</style>
